export default from './create-post-cta';



// WEBPACK FOOTER //
// ./app/components/create-post-cta/index.js